import React from "react";
import "./ComplaintInfo.scss";
import downloadButton from "../../../assets/images/download.svg";

function ComplaintDescription() {
    return (
        <div className={'complaintDescription'}>
            We've outlined the next steps after submitting a complaint
            <a href={`${window.raeEnv.documentsUrl}complaints-handling-process.pdf`} target="_blank" rel="noopener noreferrer" className={'inlineLink'} style={{marginLeft: '4px'}}>
                here <img src={downloadButton} className="download-img" alt='Download'/>
            </a>
            . Our complaints procedure is designed to help resolve your issue quickly
            and fairly, and we'll do our best to put things right for you.
            <p style={{marginTop: "10px"}}>
                If you're still not happy, you may refer your complaint to the Financial Ombudsman
                Service (FOS) at:
                <a href="http://www.financial-ombudsman.org.uk" target="_blank" rel="noreferrer" className={'complaintInfo_externalLink'} style={{marginLeft: '4px'}}>
                    www.financial-ombudsman.org.uk
                </a>.
            </p>
        </div>
    );
}

export default ComplaintDescription;
